import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";
import { blockContacts, childContacts } from "../../AxiosRtk/ChildContacts";
import { useHistory } from "react-router-dom";
import LoadingIndicator from "../../../../setup/Loader/LoaderIndicator";
import { setShowMessage } from "../../AxiosRtk/successMessage";
import CommonStatus from "../Common/CommonStatus";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import BlockUnblock from "../modals/BlockUnblock";
import useLangTranslation from "../../../customHooks/languageProvider";
import { constant } from "../../../../utils/constant";
import Select from "react-select";
import KidImage from "../../../shared/KidImage/KidImage";

const ChildContacts = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { handleDeviceSelection } = useDashboardDataProvider();
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [searchContact, setSearchContact] = useState("");
  const [Loader, setLoader] = useState(false);
  const [childContactsList, setChildContactsList] = useState([]);
  const [selectedContactIds, setSelectedContactIds] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [sortedData, setSortedData] = useState([]);
  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const selectedKidData = kidList?.find((item) => item?.ID === selectedKidId); 
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getLangTranslation } = useLangTranslation();

  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );

  const handleGoBack = () => {
    history.goBack();
  };

  useEffect(() => {
    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    if (selectedDeviceData) {
      getChildContacts(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData, searchContact]);

  function getChildContacts(id) {
    setLoader(true);
    setChildContactsList([]);
    childContacts({
      deviceId: id,
      searchContact: searchContact,
    })
      .then((res) => {
        setChildContactsList(res?.data?.result);
      })
      .catch((err) => {
        console.log("rating catch error ==>>", err?.response?.data?.message);
      })
      .finally(() => {
        setLoader(false);
      });
  }

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  function handleblockContacts(blockStatus = 0) {
    if (selectedContactIds.length < 1) return;
    const payload = {
      deviceId: selectedDeviceData?.ID,
      isBlock: blockStatus,
      contactId: selectedContactIds
    };
    blockContacts(payload)
      .then((res) => {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: res?.data?.message,
            message: res?.data?.message,
          })
        );
        closeBlockModal();
        setSelectedContactIds([]);
      })
      .then(() => {
        getChildContacts(selectedDeviceData?.ID);
      })
      .catch((err) => {
        closeBlockModal();
        console.log("rating catch error ==>>", err?.response?.data?.message);
      });
  }

  const handleSelectAllChange = () => {
    setSelectAllChecked((prev) => !prev);
    setSelectedContactIds(
      selectAllChecked ? [] : childContactsList?.map((item) => item?.ID)
    );
  };
  const handleCheckboxChange = (contactId) => {
    setSelectedContactIds((prevSelectedContactIds) => {
      if (prevSelectedContactIds.includes(contactId)) {
        return prevSelectedContactIds.filter((id) => id !== contactId);
      } else {
        return [...prevSelectedContactIds, contactId];
      }
    });
  };

  const closeBlockModal = () => {
    setShowBlockModal(false);
  };

  const openBlockModal = () => {
    setShowBlockModal(true);
  };

  useEffect(() => {
    const temp = childContactsList?.map((item) => {
      return { ...item };
    });
    temp?.sort((a, b) => b.IsCallBlocked - a.IsCallBlocked);
    setSortedData(temp);
  }, [childContactsList]);

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );
  return (
    <>
      <BlockUnblock
        showModal={showBlockModal}
        closeModal={closeBlockModal}
        handleSubmit={() => {
          handleblockContacts(1);
        }}
      />
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div
                  className="d-inline-flex align-items-center lh-1 c-pointer"
                  onClick={handleGoBack}
                >
                  <div className="text-blue-900 fs-5">
                    <i
                      className={`${
                        lang?.isRTL === 1
                          ? "icon-arrow-right"
                          : "icon-arrow-left"
                      }`}
                    />
                  </div>
                  <h3 className="text-blue-900 mb-0">
                    {" "}
                    {getLangTranslation(
                      "DEVICE_DETAIL_CHILD_CONTACTS",
                      "Child's contacts"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <KidImage
                imageUrl={selectedKidData?.image}
                gender={selectedKidData?.gender}
              />
              <div>
                <h5 className="text-blue-900 mb-0">
                  {selectedKidData?.childName}
                </h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>

                <Select
                  className="custom-select"
                  classNamePrefix="custom-select"
                  placeholder={getLangTranslation(
                    "CHILD_DETAILS_SELECT_DEVICE",
                    "Select Device"
                  )}
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value === selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div
            className="alert alert-success alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
            role="alert"
          >
            <i className="icon-info-one fs-5" />
            {getLangTranslation(
              "HERE_YOU_CAN_MANAGE_CHILD_CONTACT_SELECT_NUMBER_BLOCK_ALLOWS",
              "Here you can manage your child's contacts. Select a number to block or allow."
            )}
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
          <div className="d-flex align-items-center flex-wrap flex-md-nowrap gap-3 mb-6">
            <div className="form-check ">
              <input
                className="form-check-input"
                id="enableScreenshot"
                type="checkbox"
                checked={selectedContactIds.length > 0 && selectAllChecked}
                onChange={handleSelectAllChange}
              />
              <label
                className="form-check-label text-nowrap text-dark"
                htmlFor="enableScreenshot"
              >
                {getLangTranslation(
                  "ALLOW_BLOCK_CALLS_SELECT_ALL",
                  "Select All"
                )}
              </label>
            </div>
            <button
              className="btn btn-outline-success d-inline-flex align-items-center gap-1 text-nowrap"
              onClick={() => handleblockContacts(0)}
            >
              <i className="icon-check-fill success-icon fs-5" />{" "}
              {getLangTranslation("ALLOW_BLOCK_CALLS_BUTTON_ALLOW", "Allow")}
            </button>
            <button
              className="btn btn-outline-danger d-inline-flex align-items-center gap-1 text-nowrap me-3"
              onClick={() => {
                if (selectedContactIds.length > 0) openBlockModal();
              }}
            >
              <i className="icon-ban danger-icon fs-5" />{" "}
              {getLangTranslation("ALLOW_BLOCK_CALLS_BUTTON_BLOCK", "Block")}
            </button>

            <div className="input-group ">
              <span
                className={`input-group-text fs-5 text-dark ${
                  lang?.isRTL === 1
                    ? " border-start-0 ps-0 rounded-0 rounded-end"
                    : "border-end-0 pe-0"
                }`}
                id="basic-addon3"
              >
                <i className="icon-search" id="togglePassword"></i>
              </span>
              <input
                value={searchContact}
                onChange={(e) => setSearchContact(e.target.value)}
                type="search"
                className={`form-control ${
                  lang?.isRTL === 1
                    ? " border-end-0 rounded-0 rounded-start"
                    : "border-start-0"
                }`}
                placeholder="Search"
                id="top-search"
              />
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="v-middle">
                    <div className="form-check">
                      <label
                        className="form-check-label mt-1"
                        htmlFor="taskName"
                      >
                        {getLangTranslation("ADD_CHILD_NAME", "Name")}
                      </label>
                    </div>
                  </th>
                  <th className="v-middle">
                    {getLangTranslation("PHONE_NUMBER", "Phone number")}
                  </th>
                  <th className="v-middle">
                    {getLangTranslation("DEVICE_DETAIL_ACTION", "Actions")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData?.map((item) => (
                  <tr key={item?.ID}>
                    <td className="v-middle">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={item?.ID}
                          checked={selectedContactIds.includes(item?.ID)}
                          onChange={() => handleCheckboxChange(item?.ID)}
                        />
                        <label className="form-check-label" htmlFor={item?.ID}>
                          {item?.Name}
                        </label>
                      </div>
                    </td>
                    <td className="v-middle">{item?.Number}</td>
                    <td className="v-middle">
                      <div className="d-inline-flex align-items-center gap-6">
                        {item?.IsCallBlocked === 1 ? (
                          <>
                            <i className="icon-check-fill fs-5 text-blue-50 border rounded-circle" />
                            <i className="icon-ban fs-5 text-danger border-danger border rounded-circle" />
                          </>
                        ) : (
                          <>
                            <i className="icon-check-fill fs-5 text-success border rounded-circle border-success" />
                            <i className="icon-ban  fs-5 text-blue-50 border rounded-circle" />
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!Loader && childContactsList?.length === 0 && (
              <div className="text-center my-3">
                --{" "}
                {getLangTranslation(
                  "CONTACT_NOT_EXISTS",
                  "Contact does not exist."
                )}{" "}
                --
              </div>
            )}
            {Loader && (
              <div className="text-center my-3">
                <LoadingIndicator
                  width={100}
                  height={30}
                  color={constant?.color?.DODGER_BLUE}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChildContacts;
